import React from 'react';
import { Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import AgentStats from './AgentStats';
import ApprovalQueue from './ApprovalQueue';
import { FaRobot, FaClipboardList } from 'react-icons/fa';

const MADiscoveryDashboard = () => {
  const [activeTab, setActiveTab] = React.useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Container fluid className="ma-discovery-dashboard mt-4">
      <Row>
        <Col>
          <h1 className="mb-4">
            <FaRobot className="me-3" style={{ color: '#007bff' }} />
            AI M&A Discovery Agent
          </h1>
          <p className="lead text-muted mb-4">
            Autonomous agent for discovering merger and acquisition transactions in the EDA industry using multi-source data fusion and LLM entity extraction.
          </p>
        </Col>
      </Row>

      <Nav tabs className="mb-4">
        <NavItem>
          <NavLink
            className={activeTab === '1' ? 'active' : ''}
            onClick={() => toggle('1')}
            style={{ cursor: 'pointer' }}
          >
            <FaRobot className="me-2" />
            Agent Dashboard
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === '2' ? 'active' : ''}
            onClick={() => toggle('2')}
            style={{ cursor: 'pointer' }}
          >
            <FaClipboardList className="me-2" />
            Approval Queue
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row>
            <Col>
              <AgentStats />
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row>
            <Col>
              <ApprovalQueue />
            </Col>
          </Row>
        </TabPane>
      </TabContent>

      {}
      <Row className="mt-5">
        <Col>
          <div className="alert alert-light border">
            <h6>📄 Research Implementation</h6>
            <p className="mb-0 small text-muted">
              <strong>Conference Paper:</strong> "Cost-Optimized Autonomous AI Agent for Real-Time M&A Discovery: A Multi-Source LLM Approach"
              <br />
              <strong>Institution:</strong> Technical University of Sofia
              <br />
              <strong>Technology:</strong> GPT-4o-mini (OpenAI), Google Custom Search API, RSS Feeds, Jaro-Winkler Deduplication
              <br />
              <strong>Monthly Cost:</strong> ~€0.06/month (~$0.07 USD) | <strong>Precision:</strong> 85%+ | <strong>Recall:</strong> 91%+
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default MADiscoveryDashboard;
